import { render, staticRenderFns } from "./WithdrawalView.vue?vue&type=template&id=b4ab7050&lang=pug&"
import script from "./WithdrawalView.vue?vue&type=script&lang=js&"
export * from "./WithdrawalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports